var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2387_10938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9323 3.9894L8.16306 6.6045C7.87115 6.88017 7.38462 6.67578 7.38462 6.26896V4.88505C4.60433 4.90371 3.43142 5.5603 4.21587 8.1803C4.30208 8.46825 3.96883 8.69121 3.73498 8.51357C2.98562 7.94434 2.30769 6.85555 2.30769 5.75653C2.30769 2.98852 4.56921 2.43923 7.38462 2.42361V1.03871C7.38462 0.631516 7.87148 0.427785 8.16306 0.70317L10.9323 3.31832C11.125 3.5003 11.1252 3.80727 10.9323 3.9894ZM7.38462 7.86786V9.19232H1.23077V3.03848H2.20992C2.241 3.03846 2.27175 3.03216 2.30033 3.01995C2.32891 3.00775 2.35473 2.98989 2.37623 2.96746C2.66379 2.66807 2.99617 2.43111 3.35727 2.24292C3.57131 2.13136 3.492 1.80771 3.25063 1.80771H0.923077C0.413269 1.80771 0 2.22098 0 2.73079V9.50002C0 10.0098 0.413269 10.4231 0.923077 10.4231H7.69231C8.20212 10.4231 8.61539 10.0098 8.61539 9.50002V7.79221C8.61539 7.63282 8.45775 7.52171 8.30748 7.57486C8.0968 7.64937 7.87119 7.67166 7.65 7.6398C7.51019 7.61969 7.38462 7.72661 7.38462 7.86786Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2387_10938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.0769,
    height: 12,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareSquare);
export default __webpack_public_path__ + "static/media/share-square.5b3456b9898336ea418099f70b68963f.svg";
export { ForwardRef as ReactComponent };